export function makeMeTwoDigits(n: any) {
    if (n < 1) {
      return "0" + "0";
    } else {
      return (n < 10 ? "0" : "") + n;
    }
  }